import type { OrganizationState } from '../../types';
import { joinWithAnd } from '../../../utilities/text';
import { employeeNamesAsText } from '../employees/employee-names-as-text';
import { partnerNamesAsText } from '../partners/partner-names-as-text';

export function namesAsText(
  item: { employees?: string[]; partners?: string[] },
  o: OrganizationState,
  includeOrganization: boolean,
): string {
  const e = employeeNamesAsText(item, o);
  const p = partnerNamesAsText(item, o);

  const n: string[] = [];
  if (includeOrganization) {
    n.push(o.name);
  }

  if (e !== 'Ingen') {
    n.push(e);
  }
  if (p !== 'Ingen') {
    n.push(p);
  }

  if (n.length === 0) {
    return 'Ingen';
  } else {
    return joinWithAnd(n);
  }
}
